/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/userSettingsMappers";
import * as Parameters from "../models/parameters";
/** Class representing a UserSettings. */
var UserSettings = /** @class */function () {
  /**
   * Create a UserSettings.
   * @param {LabsApiClientContext} client Reference to the service client.
   */
  function UserSettings(client) {
    this.client = client;
  }
  UserSettings.prototype.get = function (options, callback) {
    return this.client.sendOperationRequest({
      options: options
    }, getOperationSpec, callback);
  };
  UserSettings.prototype.createOrUpdate = function (body, options, callback) {
    return this.client.sendOperationRequest({
      body: body,
      options: options
    }, createOrUpdateOperationSpec, callback);
  };
  UserSettings.prototype.update = function (body, options, callback) {
    return this.client.sendOperationRequest({
      body: body,
      options: options
    }, updateOperationSpec, callback);
  };
  return UserSettings;
}();
export { UserSettings };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var getOperationSpec = {
  httpMethod: "GET",
  path: "api/me/settings",
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "Object"
            }
          }
        }
      }
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var createOrUpdateOperationSpec = {
  httpMethod: "PUT",
  path: "api/me/settings",
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  requestBody: {
    parameterPath: "body",
    mapper: {
      required: true,
      serializedName: "body",
      type: {
        name: "Dictionary",
        value: {
          type: {
            name: "Object"
          }
        }
      }
    }
  },
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "Object"
            }
          }
        }
      }
    },
    201: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "Object"
            }
          }
        }
      }
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var updateOperationSpec = {
  httpMethod: "PATCH",
  path: "api/me/settings",
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  requestBody: {
    parameterPath: "body",
    mapper: {
      required: true,
      serializedName: "body",
      type: {
        name: "Dictionary",
        value: {
          type: {
            name: "Object"
          }
        }
      }
    }
  },
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "Object"
            }
          }
        }
      }
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};